var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resolvedSrc)?_c('img',{attrs:{"src":_vm.resolvedSrc},on:{"error":function($event){return _vm.$emit('error', $event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }